import { render } from "./DispRelated.vue?vue&type=template&id=80e0181a"
import script from "./DispRelated.vue?vue&type=script&lang=js"
export * from "./DispRelated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Custom/DispRelated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80e0181a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80e0181a', __exports__)) {
    console.log('reload')
    api.reload('80e0181a', __exports__)
  }
  
  module.hot.accept("./DispRelated.vue?vue&type=template&id=80e0181a", () => {
    console.log('re-render')
    api.rerender('80e0181a', render)
  })

}


export default __exports__